import type { TabType } from './types';

/** Block overview palette + Chakra semantic token keys — see `styles/theme/index.ts` */
export { BLOCK_OVERVIEW_COLORS, BLOCK_OVERVIEW_TOKEN } from 'styles/theme';

export const HEADER_CONFIG = {
  // Content-derived, not a magic number: 6px padding + 30px control row + 6px
  // padding + 1px border. Keep this in step with the `py` on the header Box —
  // it is the one place the viewport maths reads the header's height from
  // (TabContent subtracts it), so a `py` change without a change here silently
  // gives every page the wrong amount of room.
  HEIGHT: '44px',
  BG_COLOR: 'white',
  NAVIGATION_HEIGHT: '30px',
} as const;

export const COLORS = {
  ACTIVE_BG: '#6B5FC6',
  ACTIVE_HOVER: '#6347CC',
  ACTIVE_PRESSED: '#5639B5',
  INACTIVE_TEXT: 'gray.700',
  ACTIVE_TEXT: '#FFFFFF',
} as const;

export const MENU_ITEMS = {
  blocks: ['All Blocks', 'Financial Blocks', 'Custom Blocks'],
  dimensions: ['Time Dimensions', 'Product Dimensions', 'Location Dimensions'],
  import: ['Import CSV', 'Import Excel', 'Connect Database'],
} as const;

export const BUTTON_STYLES = {
  fontWeight: 900,
  fontSize: '16px',
  lineHeight: '100%',
  letterSpacing: '0%',
  textAlign: 'center' as const,
  // borderRadius: '12px',
  width: 'auto',
} as const;

export const MODEL_TAB_CONFIG: ReadonlyArray<{
  key: string;
  name: string;
  urlValue: string;
  tabType: TabType;
}> = [
  { key: 'dashboard', name: 'Dashboards', urlValue: 'dashboards', tabType: 'dashboard' },
  { key: 'blocks', name: 'Blocks', urlValue: 'blocks', tabType: 'blocks' },
  { key: 'dimensions', name: 'Dimensions', urlValue: 'dimensions', tabType: 'dimensions' },
  { key: 'data', name: 'Data', urlValue: 'data', tabType: 'import' },
] as const;

export const DEFAULT_MODEL_TAB_URL = 'dashboards';

export const getTabFromUrlValue = (urlValue: string | null): TabType | null => {
  if (!urlValue) {
    return null;
  }

  if (urlValue === 'dashboard') {
    return 'dashboard';
  }

  const tabConfiguration = MODEL_TAB_CONFIG.find((tab) => tab.urlValue === urlValue);
  return tabConfiguration?.tabType ?? null;
};

export const getUrlValueFromTab = (tabType: TabType): string => {
  const tabConfiguration = MODEL_TAB_CONFIG.find((tab) => tab.tabType === tabType);
  return tabConfiguration?.urlValue ?? DEFAULT_MODEL_TAB_URL;
};

/** Named tab keys, so NavigationBar's many `tabKey === '...'` branches
 * reference one place instead of repeating the raw string literal. */
export const TAB_KEYS: Record<'DASHBOARD' | 'BLOCKS' | 'DIMENSIONS' | 'IMPORT', TabType> = {
  DASHBOARD: 'dashboard',
  BLOCKS: 'blocks',
  DIMENSIONS: 'dimensions',
  IMPORT: 'import',
};
